import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { gaEvent } from "@/lib/analytics";

export const cookieChoice = () => localStorage.getItem("dl_cookies");

export const CookieBanner = () => {
  const [visible, setVisible] = useState(() => !localStorage.getItem("dl_cookies"));

  useEffect(() => {
    const reopen = () => setVisible(true);
    window.addEventListener("dl-cookie-reopen", reopen);
    return () => window.removeEventListener("dl-cookie-reopen", reopen);
  }, []);

  const choose = (value) => {
    localStorage.setItem("dl_cookies", value);
    if (value === "essential") {
      localStorage.removeItem("dane_visitor_id");
    }
    if (value === "all") {
      try {
        window.gtag?.("consent", "update", {
          analytics_storage: "granted",
          ad_storage: "denied",
          ad_user_data: "denied",
          ad_personalization: "denied",
        });
      } catch {}
      if (window.__loadPH) window.__loadPH();
      if (window.__loadVisitorPixel) window.__loadVisitorPixel();
    }
    gaEvent("cookie_choice", { choice: value === "all" ? "allow" : "essential_only" });
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 w-full z-[60] border-t border-[#2E2E2E] bg-[#111111] px-5 py-5" data-testid="cookie-banner">
      <div className="max-w-[960px] mx-auto flex flex-col md:flex-row md:items-center gap-4">
        <p className="text-base font-medium text-[#D6D6D6] leading-[1.6] flex-1">
          Essential cookies keep your conversation working while you're here. Only if you allow it, this site also sets
          a small note so I recognize you when you come back, Google Analytics to understand how the site is used,
          and visitor identification technology. <Link to="/privacy" className="text-white font-semibold underline underline-offset-4" data-testid="cookie-privacy-link">The details are in the privacy policy.</Link>
        </p>
        <div className="flex gap-3 shrink-0">
          <button onClick={() => choose("essential")} data-testid="cookie-essential-button"
            className="rounded-full bg-white text-black font-semibold text-base px-6 py-3 hover:bg-[#D6D6D6] transition-colors duration-150">
            Essential only
          </button>
          <button onClick={() => choose("all")} data-testid="cookie-allow-button"
            className="rounded-full border border-[#2E2E2E] text-white font-semibold text-base px-6 py-3 hover:bg-[#1A1A1A] transition-colors duration-150">
            Allow
          </button>
        </div>
      </div>
    </div>
  );
};
